export default __webpack_public_path__ + "static/media/sidebar-purple@2x.607f9a7b.png";